import { request } from "../../proto/bundle";
import { getConnectionPool } from "../../core/connectionPool";
import { TableUser } from "./tableUser";
import { User } from "./user";
import { Organization } from "./orgnization";
import { getUserOrOrg } from "./auth";
import { checkMigrate, globalCache } from "../../init/sdkInit";
import { hashString } from "../../utils/hash";

export function validateEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/; // strict checking validity of email
    return emailRegex.test(email);
}

export class ManageUser {
    constructor(

    ) { }
    private static verifyEmail(
        email: string
    ): boolean {
        return validateEmail(email);
    }

    private static cleanedEmailString(
        emailString: string
    ): string[] {
        return emailString.trim().split(",")
    }

    public static async inviteUsersList(
        emailString: string
    ): Promise<[string[], string[], string[]]> {
        return this.inviteUsers(emailString);
    }

    public static async inviteUserFile(filePath: string) {
        // if (typeof process !== "undefined" && process.versions?.node) {
        //     const fs = await import("fs");

        //     if (!fs.existsSync(filePath)) {
        //         throw new Error(`File does not exist: ${filePath}`);
        //     }

        //     const data = fs.readFileSync(filePath, "utf-8");
        //     const cleanedData = data.replace(/\s+/g, "");
        //     return this.inviteUsers(cleanedData);
        // } else {
        //     throw new Error("inviteUserFile is only supported in Node.js environments.");
        // }
    }


    private static async inviteUsers(
        emailString: string
    ): Promise<[string[], string[], string[]]> {
        let userEmails = [];
        let statuses = [];
        let messages = [];
        const emails = this.cleanedEmailString(emailString);
        for (const email of emails) {
            if (!this.verifyEmail(email)) {
                userEmails.push(email);
                statuses.push("Failed");
                messages.push("Invalid Email");
                continue;
            }
            const inviteUser = request.InviteUser.create({ email })
            const req = request.Request.create({ id: null, reqCreateTime: Date.now(), inviteUser });
            const pool = await getConnectionPool();
            const resp = await pool.sendAndWait(req);

            checkMigrate(resp.inviteUser.status)
            userEmails.push(email);
            if (resp?.inviteUser?.status != 0) {
                statuses.push("Failed");
                messages.push(resp?.inviteUser?.message ?? "Failed to Invite")
            } else {
                messages.push(resp?.inviteUser?.message ?? "Invite Success")
                statuses.push("Success");
            }
        }
        return Promise.resolve([userEmails, statuses, messages]);
    }

    public static async updateUser(
        emailOfUser: string,
        roles: string[],
        teams: string[]
    ): Promise<boolean> {

        const setRolesTeamsToUser = request.SetRolesTeamsToUser.create({ emailOfUser: emailOfUser, nameOfRoles: roles || null, nameOfTeams: teams || null });
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), setRolesTeamsToUser });
        const pool = await getConnectionPool();
        const resp = await pool.sendAndWait(req);
        checkMigrate(resp.setRolesTeamsToUser.status)
        if (resp?.setRolesTeamsToUser?.status != 0) {
            throw new Error(resp?.setRolesTeamsToUser?.message ?? "Error while updating " + emailOfUser)
        }
        return Promise.resolve(true);
    }

    public static async getProfilePic()
        : Promise<Uint8Array> {
        // TODO: should implement
        return Promise.resolve(new Uint8Array());
    }

    public static async setProfilePic(
        profilePic: Uint8Array,
        profilePicName: string
    ) {
        // TODO: should implement
    }
    // list users without themselves
    public static async listUsers(): Promise<TableUser[]> {
        const pool = await getConnectionPool();
        let usersList: TableUser[] = [];
        let pageToken: Uint8Array | undefined = undefined;

        while (true) {
            const req = request.Request.create({
                id: null,
                reqCreateTime: Date.now(),
                listUsers: request.ListUsers.create({
                    pageTokenListUser: pageToken,
                    pageSize: pageToken ? undefined : 20,
                }),
            });

            const resp = await pool.sendAndWait(req);
            checkMigrate(resp.listUsers.status)

            if (!resp.listUsers || resp.listUsers.status !== 0) {
                throw new Error(`Failed to list users (${resp.listUsers?.status})`);
            }

            const result = resp.listUsers;

            for (const user of result.users || []) {
                if (user.email != pool.getEmail()) {
                    usersList.push(new TableUser(
                        user.email,
                        user.rolesOfUser,
                        user.teamsOfUser,
                        user.blockStatus,
                    ));
                }
            }

            pageToken = result.pageTokenListUser ?? undefined;

            if (!pageToken || pageToken.length === 0) {
                break; // End of pagination
            }
        }
        console.log("User list", usersList);
        return usersList;
    }

    public async removeUsers(
        emails: string[]
    ) {

    }

    public static async getStorageSize(): Promise<number | Long> {
        const getStorageValue = request.GetStorageValue.create({})
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), getStorageValue })
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.getStorageValue.status)

        if (resp?.getStorageValue?.status !== 0) {
            throw new Error(resp?.getStorageValue?.message ?? "Failed to get storage size")
        }

        sessionStorage.setItem("memory", (resp?.getStorageValue?.limit ?? 100).toString())

        return resp?.getStorageValue?.value ?? -1
    }

    public static async changePasswordWithOldPassword(
        oldPassword: string,
        newPassword: string
    ) {
        const old_hashed = await hashString(oldPassword)
        const new_hash = await hashString(newPassword)
        const changePassword = request.ChangePassword.create({ email: "not@used.in", oldPassword: old_hashed, newPassword: new_hash })
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), changePassword })
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.changePassword.status)

        if (resp?.changePassword?.status !== 0) {
            throw new Error(resp?.changePassword?.message ?? "Failed to change password(old password)")
        }
    }

    public static async changePasswordWithToken(
        email: string,
        token: Uint8Array,
        newPassword: string,
        question: string,
        answer: string,
    ) {
        const questionAnswer = request.QueAndAns.create({ question, answer })
        const new_hash = await hashString(newPassword)
        const changePassword = request.ChangePassword.create({ email, token, newPassword: new_hash, queAndAns: questionAnswer })
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), changePassword })
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.changePassword.status)

        if (resp?.changePassword?.status !== 0) {
            throw new Error(resp?.changePassword?.message ?? "Failed to change password(token)")
        }

        if (resp?.changePassword?.email == null || resp?.changePassword?.email == undefined || resp?.changePassword?.email == "") {
            throw new Error("Password reset unsuccessful")
        }

        pool.setEmail(resp?.changePassword?.email ?? "")
    }

    public static async changePasswordForOrgUser(
        email: string
    ) {
        // console.log("Change password for org user called with email:", email);
        const pool = await getConnectionPool()
        const passwordReset = request.PasswordReset.create({ email: pool.getEmail(), ouEmail: email })
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), passwordReset })
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.passwordReset.status)

        if (resp?.passwordReset?.status !== 0) {
            throw new Error(resp?.passwordReset?.message ?? "Failed to reset password")
        }
    }

    public static async resetPassword(
        email: string
    ) {
        const passwordReset = request.PasswordReset.create({ email })
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), passwordReset })
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.passwordReset.status)

        if (resp?.passwordReset?.status !== 0) {
            throw new Error(resp?.passwordReset?.message ?? "Failed to reset password")
        }
    }

    public static async resetTotp(

    ): Promise<string> {
        const resetTOTP = request.ResetTOTP.create({})
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), resetTOTP })
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.resetTOTP.status)

        if (resp?.resetTOTP?.status !== 0) {
            throw new Error("Failed to reset TOTP")
        }

        if (resp?.resetTOTP?.totpUri == undefined || resp?.resetTOTP?.totpUri == null) {
            throw new Error("Failed to get new TOTP string")
        }

        return Promise.resolve(resp?.resetTOTP?.totpUri ?? "")
    }

    public static async getUserDetails(
        email?: string,
        forceRefresh?: boolean
    ): Promise<User | Organization> {
        const pool = await getConnectionPool()
        const emailToGet = email == undefined || email == null || email == "" ? pool.getEmail() : email;
        return await getUserOrOrg(emailToGet, forceRefresh === true)
    }

    public static async setUserDetails(
        first_name: string,
        last_name: string,
        phone: string,
        address: string,
        location: string,
        profilePic?: Uint8Array,
    ) {
        const userInfo = await this.getUserDetails();
        if (userInfo instanceof User) {
            const firstname = first_name;
            const lastname = last_name;
            const phoneNumber = phone;
            const addressInfo = address;
            const locationInfo = location;
            const userProfile = request.UserProfile.create({
                firstname,
                lastname,
                phone: phoneNumber,
                address: addressInfo,
                location: locationInfo,
                ...(profilePic !== undefined && { profilePicture: profilePic ?? new Uint8Array() }),
            });
            const pool = await getConnectionPool();
            const userProfileMeta = request.UserProfileMeta.create({ userObj: userProfile });
            const setUser = request.SetUser.create({ email: pool.getEmail(), usermeta: userProfileMeta });
            const req = request.Request.create({ id: null, reqCreateTime: Date.now(), setUser });
            const resp = await pool.sendAndWait(req);
            checkMigrate(resp.setUser.status)
            if (resp?.setUser?.status !== 0) {
                throw new Error("Failed to set user details");
            }
            // Update cache with the user we just set so UI shows new/cleared profile picture immediately
            const updatedUser = new User(
                userInfo.getEmail(),
                userInfo.getTotpUri() ?? "",
                userInfo.getOperations(),
                firstname,
                lastname,
                userInfo.getUserType(),
                userInfo.getOrganization(),
                phoneNumber,
                addressInfo,
                userInfo.getPlan(),
                locationInfo,
                profilePic !== undefined ? (profilePic?.length ? profilePic : new Uint8Array()) : userInfo.getProfilePicture?.()
            );
            globalCache.set(pool.getEmail() + "UserDetails", updatedUser);
        } else {
            throw new Error("User details can only be set for User type, not Organization");
        }
    }

    public static async setOrganizationDetails(
        phone: string,
        address: string,
        taxId: string,
        vatID: string,
        registrationNumber: string,
        location: string,
        logo?: Uint8Array,
    ) {
        console.log("location", location);
        const OrgInfo = await this.getUserDetails(undefined, true);
        if (OrgInfo instanceof Organization) {
            const phoneNumber = phone;
            const addressInfo = address;
            const taxIdInfo = taxId;
            const vatIDInfo = vatID;
            const registrationNumberInfo = registrationNumber;

            const orgProfile = request.OrganizationProfile.create({
                phone: phoneNumber,
                address: addressInfo,
                taxId: taxIdInfo,
                vatId: vatIDInfo,
                registrationId: registrationNumberInfo,
                location: location,
                ...(logo !== undefined && { logo: logo ?? new Uint8Array() }),
            });
            const pool = await getConnectionPool();
            const orgProfileMeta = request.UserProfileMeta.create({ organizationObj: orgProfile });
            const setUser = request.SetUser.create({ email: pool.getEmail(), usermeta: orgProfileMeta });
            const req = request.Request.create({ id: null, reqCreateTime: Date.now(), setUser });
            const resp = await pool.sendAndWait(req);
            checkMigrate(resp.setUser.status)
            if (resp?.setUser?.status !== 0) {
                throw new Error("Failed to set organization details");
            }
            // Update cache with the org we just set so UI gets the new logo immediately
            // instead of refetching (GetUser can return stale data before backend persists)
            const updatedOrg = new Organization(
                OrgInfo.getEmail(),
                OrgInfo.getName(),
                OrgInfo.getTotpUri(),
                phoneNumber,
                addressInfo,
                taxIdInfo,
                vatIDInfo,
                registrationNumberInfo,
                OrgInfo.getOrgId(),
                OrgInfo.getPlan(),
                (logo !== undefined ? (logo?.length ? logo : new Uint8Array()) : OrgInfo.getLogo()) ?? new Uint8Array(),
                OrgInfo.getLocation() ?? location,
                OrgInfo.getPlanExpiry(),
            );
            globalCache.set(pool.getEmail() + "UserDetails", updatedOrg);
        } else {
            throw new Error("Organization details can only be set for Organization type, not User");
        }
    }
    public static async removeOU(ou_email: string, totp: string) {
        const pool = await getConnectionPool();
        const removeOrganizationUser = request.RemoveOrganizationUser.create({
            email: ou_email,
            totp: totp
        })
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), removeOrganizationUser });
        const resp = await pool.sendAndWait(req);
        checkMigrate(resp.removeOrganizationUser.status)
        if (resp?.removeOrganizationUser?.status !== 0) {
            throw new Error("Failed to remove user");
        }
    }
}